import microuniversoApi from "app/api/microuniversoApi";
import store from "app/redux/store/store";
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import globalMU from "globalMU";
import { tratamentoErroPadrao } from "../tratamentoErroPadrao";

export async function recalcularPrecos(recalcular:boolean) {
    try { 
        const reposta = await microuniversoApi.Orcamento.recalcularPrecos(store.getState().orcamento.IdentificadorOrcamento,recalcular)

        const orcamentoAtualizado = await microuniversoApi.Orcamento.obterItensTotaisOrcamento(store.getState().orcamento.IdentificadorOrcamento)

        store.dispatch(sobrescreverInformacoesAction({
            ...orcamentoAtualizado,
            RecalcularPrecos: recalcular
        }))
    } 
    catch (e) {
        tratamentoErroPadrao(e);
    }
    finally {
        globalMU.unblockUI()
    }
}
